import { render, staticRenderFns } from "./project.vue?vue&type=template&id=1a36a8c1&scoped=true"
import script from "./project.vue?vue&type=script&lang=js"
export * from "./project.vue?vue&type=script&lang=js"
import style0 from "./project.vue?vue&type=style&index=0&id=1a36a8c1&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a36a8c1",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\code\\git\\platform_el\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1a36a8c1')) {
      api.createRecord('1a36a8c1', component.options)
    } else {
      api.reload('1a36a8c1', component.options)
    }
    module.hot.accept("./project.vue?vue&type=template&id=1a36a8c1&scoped=true", function () {
      api.rerender('1a36a8c1', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/dataCenter/archives/project.vue"
export default component.exports